<template>
  <!-- <font-awesome-icon icon="faCircleNotch" spin /> -->
  <div class="spinner-wrapper">
    <div class="spinner"></div>
    <img src="../assets/img/gettyimages-g.svg" class="gi-g"/>
  </div>
</template>

<script>
export default {

};
</script>

<style scoped>
.spinner-wrapper {
  margin: 0 auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}
.gi-g {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 50px;
}
.spinner {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 5px var(--getty-purple) solid;
  position: relative;
  animation-name: spin;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.spinner:after {
  content: "";
  position: absolute;
  left: -7px;
  width: 9px;
  background-color: #fff;
  height: 8px;
  top: calc(50% - 4px);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>